import React from 'react';
import { Plus } from '@gravity-ui/icons';
import { Button, Icon, Label } from '@gravity-ui/uikit';
import set from 'lodash/set';
import { Controller, OBJECT_ARRAY_CNT, OBJECT_ARRAY_FLAG, isBooleanSpec, isCorrectSpec, isNumberSpec, isStringSpec, transformArrIn, } from '../../../../core';
import { block } from '../../../utils';
import './ArrayBase.css';
const b = block('array-base');
export const ArrayBase = ({ spec, name, arrayInput, input }) => {
    const keys = React.useMemo(() => Object.keys(arrayInput.value || {})
        .filter((k) => k !== OBJECT_ARRAY_FLAG && k !== OBJECT_ARRAY_CNT)
        .map((k) => k.split('<').join('').split('>').join(''))
        .sort((a, b) => Number(a) - Number(b)), [arrayInput.value]);
    const itemSpecCorrect = React.useMemo(() => isCorrectSpec(spec.items), [spec.items]);
    const itemsPrimitive = React.useMemo(() => {
        return isBooleanSpec(spec.items) || isNumberSpec(spec.items) || isStringSpec(spec.items);
    }, [spec.items]);
    const getItemSpec = React.useCallback((idx) => {
        if (!itemSpecCorrect) {
            return null;
        }
        const itemSpec = Object.assign({}, spec.items);
        itemSpec.viewSpec = Object.assign(Object.assign({}, itemSpec.viewSpec), { layoutTitle: itemSpec.viewSpec.layoutTitle
                ? `${itemSpec.viewSpec.layoutTitle} ${idx + 1}`
                : `${idx + 1}` });
        return itemSpec;
    }, [spec.items, itemSpecCorrect]);
    const parentOnChange = React.useCallback((childName, childValue, childErrors) => input.onChange((currentValue) => set(Object.assign({}, currentValue), childName.split(`${input.name}.`).join(''), childValue), childErrors), [input.onChange, input.name]);
    const AddButton = React.useCallback(() => {
        let onClick = () => arrayInput.onItemAdd(undefined);
        let qa = `${name}-add-item`;
        let title = spec.viewSpec.itemLabel;
        if (!arrayInput.value && spec.defaultValue) {
            onClick = () => {
                input.onChange(transformArrIn(spec.defaultValue));
            };
            qa = `${name}-init-arr`;
            title = spec.viewSpec.layoutTitle;
        }
        return (React.createElement(Button, { onClick: onClick, disabled: spec.viewSpec.disabled, qa: qa, className: b('add-button', { right: spec.viewSpec.addButtonPosition === 'right' }) },
            React.createElement(Icon, { data: Plus, size: 14 }),
            title || null));
    }, [
        arrayInput,
        input,
        name,
        spec.defaultValue,
        spec.viewSpec.disabled,
        spec.viewSpec.itemLabel,
        spec.viewSpec.layoutTitle,
        spec.viewSpec.addButtonPosition,
    ]);
    const items = React.useMemo(() => keys.map((key, idx) => {
        var _a;
        const itemSpec = getItemSpec(idx);
        if (!itemSpec) {
            return null;
        }
        const showItemPrefix = idx !== 0 && spec.viewSpec.itemPrefix;
        return (React.createElement(React.Fragment, { key: `${name}.<${key}>` },
            showItemPrefix ? (React.createElement(Label, { size: "m", className: b('item-prefix') }, spec.viewSpec.itemPrefix)) : null,
            React.createElement(Controller, { value: (_a = input.value) === null || _a === void 0 ? void 0 : _a[`<${key}>`], parentOnChange: parentOnChange, parentOnUnmount: input.parentOnUnmount, spec: itemSpec, name: `${name}.<${key}>` })));
    }), [
        keys.join(''),
        name,
        getItemSpec,
        parentOnChange,
        input.parentOnUnmount,
        input.value,
        spec.viewSpec.itemPrefix,
    ]);
    if (!itemSpecCorrect) {
        return null;
    }
    return (React.createElement("div", { className: b({ 'add-button-right': spec.viewSpec.addButtonPosition === 'right' }) },
        React.createElement("div", { className: b('items-wrapper', {
                'add-button-down': spec.viewSpec.addButtonPosition !== 'right' && keys.length > 0,
                'items-primitive': itemsPrimitive,
            }) }, items),
        React.createElement(AddButton, null)));
};
